import { Price } from './price.model';
import { PricePerUnit } from './price-per-unit.model';
import { ProductPromotion } from './product-promotion.model';
import { Field, Model, Type, deserialize, ArraySerializer } from 'serialize-ts';
import { ModelMetadataSerializer } from 'serialize-ts/dist/serializers/model-metadata.serializer';
import { VolumePrice } from '~shared/models/product-card/volume-price.model';
import { ReferencePrice } from '~shared/models/product-card/reference-price.model';
import { UnitPrice } from '~shared/models/product-card/unit-price.model';

@Model()
export class BestOffer {
  @Field()
  id: string;

  @Field()
  promotion: ProductPromotion;

  @Field()
  @Type(new ModelMetadataSerializer(PricePerUnit))
  pricePerUnit?: PricePerUnit;

  @Field()
  @Type(new ArraySerializer(new ModelMetadataSerializer(VolumePrice)))
  volumePrice?: VolumePrice[];

  @Field()
  @Type(new ModelMetadataSerializer(Price))
  price: Price;

  @Field()
  referencePrice: ReferencePrice;

  @Field()
  unitPrice: UnitPrice;

  @Field()
  basePrice?: PricePerUnit;

  @Field()
  quantity?: number;

  @Field()
  origin?: string;

  @Field()
  destination?: string;

  @Field()
  sellerName?: string;

  static map(response: any, hasPromotion: boolean): BestOffer {
    const offer = deserialize(response, BestOffer);

    offer.promotion = offer.promotion || (hasPromotion ? new ProductPromotion() : null);

    return offer;
  }
}
